var _rect, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRentaiMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 72,
    viewBox: "0 0 66 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.5068,
    height: 46.5068,
    rx: 7.12985,
    transform: "matrix(0.709574 0.704631 -0.709574 0.704631 32.9998 0)",
    fill: "url(#paint0_linear_5168_423)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.5987,
    y: 18.5357,
    width: 59.2654,
    height: 58.9287
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.73px)",
      clipPath: "url(#bgblur_0_5168_423_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5168_423)",
    "data-figma-bg-blur-radius": 5.46435
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.06305,
    y: 24,
    width: 48.3367,
    height: 48,
    rx: 12,
    fill: "#BCE4F1",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 33.2456,
    y: 29.0357,
    width: 16.4712,
    height: 34.2007
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.73px)",
      clipPath: "url(#bgblur_1_5168_423_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5168_423)",
    "data-figma-bg-blur-radius": 5.46435
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.138 39.3561C39.797 39.3561 38.71 38.269 38.71 36.928C38.71 35.5871 39.797 34.5 41.138 34.5H41.8245C43.1654 34.5 44.2525 35.5871 44.2525 36.928C44.2525 38.269 43.1654 39.3561 41.8245 39.3561H41.138ZM41.4812 57.772C39.9507 57.772 38.71 56.5312 38.71 55.0007V45.1624C38.71 43.6319 39.9507 42.3911 41.4812 42.3911C43.0118 42.3911 44.2525 43.6319 44.2525 45.1624V55.0007C44.2525 56.5312 43.0118 57.772 41.4812 57.772Z",
    fill: "#DBF6FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 17.1934,
    y: 29.0357,
    width: 16.4712,
    height: 34.2007
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.73px)",
      clipPath: "url(#bgblur_2_5168_423_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_5168_423)",
    "data-figma-bg-blur-radius": 5.46435
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0858 39.3561C23.7448 39.3561 22.6578 38.269 22.6578 36.928C22.6578 35.5871 23.7448 34.5 25.0858 34.5H25.7723C27.1133 34.5 28.2003 35.5871 28.2003 36.928C28.2003 38.269 27.1133 39.3561 25.7723 39.3561H25.0858ZM25.4291 57.772C23.8985 57.772 22.6578 56.5312 22.6578 55.0007V45.1624C22.6578 43.6319 23.8985 42.3911 25.4291 42.3911C26.9596 42.3911 28.2003 43.6319 28.2003 45.1624V55.0007C28.2003 56.5312 26.9596 57.772 25.4291 57.772Z",
    fill: "#DBF6FF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5168_423",
    x: 3.5987,
    y: 18.5357,
    width: 59.2654,
    height: 58.9287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.273217,
    dy: 0.136609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5168_423"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5168_423_clip_path",
    transform: "translate(-3.5987 -18.5357)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.06305,
    y: 24,
    width: 48.3367,
    height: 48,
    rx: 12
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5168_423",
    x: 33.2456,
    y: 29.0357,
    width: 16.4712,
    height: 34.2007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.273217,
    dy: 0.136609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5168_423"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_5168_423_clip_path",
    transform: "translate(-33.2456 -29.0357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.138 39.3561C39.797 39.3561 38.71 38.269 38.71 36.928C38.71 35.5871 39.797 34.5 41.138 34.5H41.8245C43.1654 34.5 44.2525 35.5871 44.2525 36.928C44.2525 38.269 43.1654 39.3561 41.8245 39.3561H41.138ZM41.4812 57.772C39.9507 57.772 38.71 56.5312 38.71 55.0007V45.1624C38.71 43.6319 39.9507 42.3911 41.4812 42.3911C43.0118 42.3911 44.2525 43.6319 44.2525 45.1624V55.0007C44.2525 56.5312 43.0118 57.772 41.4812 57.772Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_5168_423",
    x: 17.1934,
    y: 29.0357,
    width: 16.4712,
    height: 34.2007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.273217,
    dy: 0.136609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5168_423"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_5168_423_clip_path",
    transform: "translate(-17.1934 -29.0357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0858 39.3561C23.7448 39.3561 22.6578 38.269 22.6578 36.928C22.6578 35.5871 23.7448 34.5 25.0858 34.5H25.7723C27.1133 34.5 28.2003 35.5871 28.2003 36.928C28.2003 38.269 27.1133 39.3561 25.7723 39.3561H25.0858ZM25.4291 57.772C23.8985 57.772 22.6578 56.5312 22.6578 55.0007V45.1624C22.6578 43.6319 23.8985 42.3911 25.4291 42.3911C26.9596 42.3911 28.2003 43.6319 28.2003 45.1624V55.0007C28.2003 56.5312 26.9596 57.772 25.4291 57.772Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5168_423",
    x1: 37.4165,
    y1: 1.96584,
    x2: 10.2746,
    y2: 67.4256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF5AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#4597F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#33F7BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentaiMark);
export default __webpack_public_path__ + "static/media/rentai_mark.ee96ed8dbc554c0c9a726f284112cf37.svg";
export { ForwardRef as ReactComponent };